import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import makeStyles from '@mui/styles/makeStyles';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import { getStores, removeStore } from 'actions/stores';
import StoresTableHead from 'pages/my-stores/stores/TableHead';
import StoresTableBody from 'pages/my-stores/stores/TableBody';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
});

const Stores = ({ userEmail }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const emailid = useSelector((state) => state?.auth?.profile?.emailid);

  useEffect(() => {
    return dispatch(getStores(userEmail || emailid));
  }, [dispatch, emailid, userEmail]);

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table>
          <StoresTableHead />
          <TableBody>
            <StoresTableBody
              removeStore={async (store) => {
                await dispatch(
                  removeStore({
                    user: userEmail || emailid,
                    storeId: store.ID,
                  })
                );
              }}
            />
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default Stores;
